import React from "react";
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  Link,
  MenuItem,
  Modal,
  TextField,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
import SlidingPanel from "react-sliding-side-panel";
import UGTable from "../../../../../Supporting files/UGTable/UGTable";
interface Props {
  attrName: any;
  open_status: boolean;
  value_update: Function;
}
const Location: React.FC<Props> = ({ open_status, attrName, value_update }) => {
  const [departmentName, setDepartmentName] = React.useState("");
  const [reportingManager, setReportingManager] = React.useState("");
  const [employeeList, setEmployeeList] = React.useState("");
  const [locationStatus, setLocationStatus] = React.useState(false);
  const [empId, setEmpId] = React.useState("");
  const [pincode, setPinCode] = React.useState("");
  const [branch, setBranch] = React.useState("");
  const [accessType, setAccessType] = React.useState("");
  const [pageStatus, setPageStatus] = React.useState<number>(1);

  // const columns: GridColDef[] = [
  //   { field: "id", headerName: "Emp. ID", width: 70 },
  //   { field: "name", headerName: "Emp. Name", width: 250 },
  //   { field: "branch", headerName: "Branch", width: 250 },
  //   { field: "cityState", headerName: "City/State", width: 250 },
  //   { field: "accessType", headerName: "Access Type", width: 250 },
  //   { field: "action", headerName: "Action", width: 250 },
  // ];
  //Table Data
  const [columns, setColumns] = React.useState([
    {
      field: "id",
      headerName: "Emp. ID",
      width: 100,
      check_status: true,
    },
    {
      field: "empfirstName",
      headerName: "Emp. First Name",
      width: 230,
      check_status: true,
    },
    {
      field: "emplastName",
      headerName: "Emp. Last Name",
      width: 230,
      check_status: true,
    },
    {
      field: "branch",
      headerName: "Branch",
      width: 200,
      check_status: true,
    },
    {
      field: "cityState",
      headerName: "city/State",
      width: 300,
      check_status: true,
    },
    {
      field: "accessType",
      headerName: "Access Type",
      width: 300,
      check_status: true,
    },
    {
      field: "status",
      headerName: "Status",
      width: 120,
      check_status: true,
      renderCell: (data: any) => {
        const { row } = data;
        return <span className={row.status}>{row.status}</span>;
      },
    },
  ]);
  const rows = [
    {
      id: 1011,
      empfirstName: "Umesh",

      emplastName: "Gemini",
      branch: "Head Office",
      cityState: "Mohali/Punjab",
      accessType: "Super Admin",
      status: "Active",
    },
    {
      id: 1012,
      empfirstName: "Umesh",
      emplastName: "Gemini",
      branch: "Head Office",
      cityState: "Mohali/Punjab",
      accessType: "Super Admin",
      status: "Pending",
    },
    {
      id: 1013,
      empfirstName: "Umesh",
      emplastName: "Gemini",
      branch: "Head Office",
      cityState: "Mohali/Punjab",
      accessType: "Super Admin",
      status: "Inprogress",
    },
    {
      id: 1014,
      empfirstName: "Umesh",
      emplastName: "Gemini",
      branch: "Head Office",
      cityState: "Mohali/Punjab",
      accessType: "Super Admin",
      status: "Pending",
    },
    {
      id: 1015,
      empfirstName: "Umesh",
      emplastName: "Gemini",
      branch: "Head Office",
      cityState: "Mohali/Punjab",
      accessType: "Super Admin",
      status: "Rejected",
    },
    {
      id: 1016,
      empfirstName: "Umesh",
      emplastName: "Gemini",
      branch: "Head Office",
      cityState: "Mohali/Punjab",
      accessType: "Super Admin",
      status: "Active",
    },
    {
      id: 1017,
      empfirstName: "Umesh",
      emplastName: "Gemini",
      branch: "Head Office",
      cityState: "Mohali/Punjab",
      accessType: "Super Admin",
      status: "Pending",
    },
    {
      id: 1018,
      empfirstName: "Umesh",
      emplastName: "Gemini",
      branch: "Head Office",
      cityState: "Mohali/Punjab",
      accessType: "Super Admin",
      status: "Rejected",
    },
    {
      id: 1019,
      empfirstName: "Umesh",
      emplastName: "Gemini",
      branch: "Head Office",
      cityState: "Mohali/Punjab",
      accessType: "Super Admin",
      status: "Active",
    },
    {
      id: 1021,
      empfirstName: "Umesh",
      emplastName: "Gemini",
      branch: "Head Office",
      cityState: "Mohali/Punjab",
      accessType: "Super Admin",
      status: "Pending",
    },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  const branch_data = [
    { key: "Head Office", value: "Head Office" },
    { key: "Head Office", value: "Head Office" },
    { key: "Head Office", value: "Head Office" },
    { key: "Head Office", value: "Head Office" },
    { key: "Head Office", value: "Head Office" },
    { key: "Head Office", value: "Head Office" },
  ];
  const access_type_data = [
    { key: "Super Admin", value: "Super Admin" },
    { key: "Admin", value: "Admin" },
    { key: "Employee", value: "Employee" },
    { key: "Super Admin", value: "Super Admin" },
    { key: "Admin", value: "Admin" },
    { key: "Employee", value: "Employee" },
  ];
  const changePageStatus = (status: boolean) => {
    if (status === true) {
      if (pageStatus < 2) {
        setPageStatus(pageStatus + 1);
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid xs={6}>
        <h3 className="mb-0">Locations</h3>
      </Grid>
      <Grid xs={6} className="text-right">
        <Link
          underline="none"
          className="blueBtn addfile"
          onClick={() => {
            setLocationStatus(true);
          }}
        >
          Add location
        </Link>
        {/* <Modal open={locationStatus} className="modalWrapper">
          <Box className="modalInner xl-width">
            <Grid container spacing={2}>
              <Grid xs={12}>
                <Link
                  
                  className="close-button"
                  onClick={() => {
                    setLocationStatus(false);
                  }}
                />
                <h5 className="popup-heading mb-5">Location</h5>
              </Grid>
            </Grid>
            <Grid container spacing={2} className="mb-4">
              <Grid xs={4} className="inputField">
                <RKTextField
                  class_name="inputField"
                  title={"Emp. ID"}
                  value={empId}
                  attrName={setEmpId}
                  value_update={updateMasterState}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={4}>
                <SelectDropdown
                  class_name="inputField"
                  title="Branch"
                  value={branch}
                  attrName={setBranch}
                  value_update={updateMasterState}
                  dropdown_data={branch_data}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField"
                  title={"Pincode"}
                  value={pincode}
                  attrName={setPinCode}
                  value_update={updateMasterState}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={4}>
                <SelectDropdown
                  class_name="inputField"
                  title="Access Type"
                  value={accessType}
                  attrName={setAccessType}
                  value_update={updateMasterState}
                  dropdown_data={access_type_data}
                  warn_status={false}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid
                xs={12}
                className="ctaBtn"
                style={{ textAlign: "center", marginTop: "20px" }}>
                <Button className="submitBtn">Submit</Button>
              </Grid>
            </Grid>
          </Box>
        </Modal> */}

        <SlidingPanel
          type={"right"}
          isOpen={locationStatus}
          size={75}
          panelClassName="slidingPanel"
          backdropClicked={() => setLocationStatus(false)}
        >
          <Box
            className={open_status == true ? "modalInner show" : "modalInner"}
          >
            {pageStatus == 2 ? null : (
              <Grid container spacing={3} alignItems="center">
                <Grid xs={6}>
                  <h4 className="mb-0 mt-4 text-left">Location</h4>
                </Grid>
              </Grid>
            )}
            {pageStatus == 2 ? null : (
              <div className="scrollable_area">
                <Grid container spacing={3}>
                  <Grid xs={12} sx={{ paddingLeft: "0px" }}>
                    <Typography>
                      <div>
                        <Grid container spacing={2} className="mb-4">
                          <Grid xs={6} className="inputField">
                            <RKTextField
                              class_name="inputField"
                              title={"Emp. ID"}
                              value={empId}
                              attrName={setEmpId}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={6}>
                            <SelectDropdown
                              class_name="inputField"
                              title="Branch"
                              value={branch}
                              attrName={setBranch}
                              value_update={updateMasterState}
                              dropdown_data={branch_data}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={6}>
                            <RKTextField
                              class_name="inputField"
                              title={"Pincode"}
                              value={pincode}
                              attrName={setPinCode}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={6}>
                            <SelectDropdown
                              class_name="inputField"
                              title="Access Type"
                              value={accessType}
                              attrName={setAccessType}
                              value_update={updateMasterState}
                              dropdown_data={access_type_data}
                              warn_status={false}
                            />
                          </Grid>
                        </Grid>
                      </div>
                    </Typography>
                  </Grid>
                </Grid>
              </div>
            )}
            .
            {pageStatus == 2 ? (
              <Grid container spacing={2}>
                <Grid xs={12} className="tick_animation">
                  <svg
                    className="checkmark"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                  >
                    <circle
                      className="checkmark__circle"
                      cx="26"
                      cy="26"
                      r="25"
                      fill="none"
                    />
                    <path
                      className="checkmark__check"
                      fill="none"
                      d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    />
                  </svg>
                  <p className="quote_success">
                    New Location Request has been added successfully!
                  </p>
                </Grid>
              </Grid>
            ) : null}
            <Grid container spacing={2}>
              {pageStatus == 2 ? null : (
                <Grid
                  xs={12}
                  style={{ textAlign: "center", position: "relative" }}
                  className="ctaBtn"
                >
                  <Button
                    variant="contained"
                    className="submitBtn fixedbtn"
                    onClick={() => {
                      changePageStatus(true);
                    }}
                  >
                    {pageStatus == 1 ? "Submit" : "Continue"}
                  </Button>
                </Grid>
              )}
            </Grid>
          </Box>
        </SlidingPanel>
      </Grid>
      <Grid xs={12}>
        <UGTable
          header_data={columns}
          data={rows}
          value_update={updateMasterState}
          attrName={"UGTable"}
        />
      </Grid>
    </Grid>
  );
};

export default Location;
